import { leaseType,leasePaymentType } from '@/util/dictList.js'
import store from '@/store/index'
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: '设置代理商评级',
  editTitle: '设置代理商评级',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  menuWidth: 300,
  // indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  addBtn: false,
  cellBtn: true,
  column: [
    {
      label: '代理商简称',
      prop: 'deptId',
      type: 'select',
      filterable: true,
      multiple: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
      display: false,
    },
    // {
    //   label: 'id',
    //   prop: 'id',
    //   search: false,
    //   display: false,
    //   hide: true,
    // },
    {
      label: '代理级别',
      prop: 'agentLevel',
      display: false,
      type: 'select',
      search: false,
      order: 10,
      hide: false,
      maxlength: 2,
      editDisplay: false,
      searchOrder: 1,
      dicData: [
        {
          label: '省代',
          value: 0
        },
        {
          label: '市代',
          value: 1
        },
        {
          label: '一般代理',
          value: 2
        }
      ],
      rules: [
        {
          required: true,
          // message: '请选择代理级别',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请选择代理级别'))
            } else {
              callback()
            }
          }
        },
      ],
    },
    {
      label: '代理商简称',
      prop: 'deptName',
      search: false,
      display: false,
      searchOrder: 999,
    },
    {
      label: '代理商评级',
      prop: 'agentRankName',
      search: false,
      display: false,
      formatter: (row, value) => {
        return value??'-'
      }
    },
    // {
    //   label: '代理商类型',
    //   prop: 'deptType',
    //   type: 'select',
    //   search: true,
    //   order: 994,
    //   display: false,
    //   dicData: [
    //     {
    //       label: '直管',
    //       value: 1,
    //     },
    //     {
    //       label: '代管',
    //       value: 2,
    //     },
    //   ],
    // },
    {
      label: '代理商评级',
      prop: 'agentRank',
      type: 'select',
      order: 993,
      search: true,
      searchOrder: 2,
      hide:true,
      editDisplay:true,
      dicData: [
        {
          label: 'S级',
          value: 1,
        },
        {
          label: 'A级',
          value: 2,
        },
        {
          label: 'B级',
          value: 3,
        },
        {
          label: 'C级',
          value: 4,
        },
      ],
      rules: [
        {
          required: false,
          message: '请选择上级机构',
          trigger: 'click',
        },
      ],
    },
    {
      label: '代理商类型',
      prop: 'deptType',
      type: 'select',
      order: 993,
      editDisplay: false,
      hide: false,
      search: true,
      dicData: [
        {
          label: '直管',
          value: 1,
        },
        {
          label: '代管',
          value: 2,
        }
      ],
      rules: [
        {
          required: false,
          message: '请选择上级机构',
          trigger: 'chenge',
        },
      ],
    },
    // {
    //   label: '是否为省代',
    //   prop: 'provincialRepresentative',
    //   type: 'radio',
    //   slot: true,
    //   formslot: true,
    //   search: true,
    //   order: 993,
    //   width: 100,
    //   display: false,
    //   dicData: [
    //     {
    //       label: '是',
    //       value: 1,
    //     },
    //     {
    //       label: '否',
    //       value: 0,
    //     },
    //   ],
    // },
    // {
    //   label: '是否正常进件',
    //   prop: 'loanInput',
    //   width: 120,
    //   type: 'radio',
    //   slot: true,
    //   formslot: true,
    //   search: true,
    //   order: 992,
    //   cell: true,
    //   display: false,
    //   dicData: [
    //     {
    //       label: '是',
    //       value: true,
    //     },
    //     {
    //       label: '否',
    //       value: false,
    //     },
    //   ],
    // },
    // {
    //   label: '是否提交返佣',
    //   prop: 'submittedCommission',
    //   width: 120,
    //   type: 'radio',
    //   slot: true,
    //   formslot: true,
    //   search: true,
    //   order: 992,
    //   cell: true,
    //   display: false,
    //   dicData: [
    //     {
    //       label: '是',
    //       value: 1,
    //     },
    //     {
    //       label: '否',
    //       value: 0,
    //     },
    //   ],
    // },
    {
      label: '代理状态',
      prop: 'stopAgent',
      minWidth: 200,
      search: false,
      display: false,
      slot: true,
      dicData: [
        {
          label: '正常代理',
          value: 1
        },
        {
          label: '终止代理',
          value: 2
        }
      ]
    },
  ],
};

// 兜底比例列表
export const ratioOption =  {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  searchMenuSpan: 6,
  labelWidth: 150,
  border: true,
  index: false,
  refreshBtn: false,
  columnBtn: false,
  searchShowBtn: false,
  selection: false,
  viewBtn: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  // menu: false,
  // editBtnText: '修改兜底比例',
  // editBtnIcon: '',
  menuWidth: 300,
  column: [
    {
      label: '产品类型',
      prop: 'productName',
      display: false,
      search: false,
      hide: false,
      showColumn: false,
    },
    {
      label: '租期',
      prop: 'tenancyTerm',
      display: false,
      search: false,
      hide: false,
      showColumn: false,
      dicData: leaseType
    },
    {
      label: '租付类型',
      prop: 'type',
      display: false,
      search: false,
      hide: false,
      showColumn: false,
      dicData: leasePaymentType,
    },
    {
      label: '租率',
      prop: 'rate',
      type: 'select',
      search: false,
      display: false,
      searchClearable: false,
      hide: false,
      formatter: (val, value, label) => {
        return val.rate ? val.rate + '%' : '-'
      }
    },
    {
      label: '兜底比例',
      prop: 'ratio',
      type: 'input',
      search: false,
      hide: false,
      showColumn: false,
      formatter: (val, value, label) => {
        return val.ratio ? val.ratio + '%' : '-'
      },
      append: '%',
      rules: [
        {
          required: true,
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('请输入数字'))
            }
            if (value && isNaN(Number(value))) {
              return callback(new Error('请输入数字'));
            }
            if (Number(value) < 0 || Number(value) > 100) {
              callback(new Error('可输入范围为1-100'));
            } else {
              callback();
            }
          },
        },
      ],
    },
  ]
};
